/** vendor */
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

/** lib */
import Loading from '../UI/Loading'
import { useToast } from '../../hooks/useToast'
import { removeImportedRecipe } from '../../services/user.service'

/** state */
import { getImportedRecipes } from '../../actions/user.actions'

/** components */
import ImportedRecipeListItem from './ImportedRecipeListItem'


export default function ImportedRecipeList({ importing = false }) {
  
    // vendor utils
    const dispatch = useDispatch()

    // a9 utils
    const toast = useToast()

    // ui states
    const [loading, setLoading] = useState(false)

    // user data
    const recipes = useSelector(state => [...state?.user_data?.imported_recipes])
    
    
    /**
     * Hooks
     */
    useEffect(() => {
        dispatch(getImportedRecipes()).then(() => {
            setLoading(false)
        }).catch(() => {
            setLoading(false)
        })
    }, [])


    /**
     * Handlers
     */
    const handleOnRemoveImportedRecipe = async (importedRecipe) => {
        try {
            setLoading(true)
            await removeImportedRecipe(importedRecipe.import_recipe_id)
            await dispatch(getImportedRecipes())
        } catch (error) {

        } finally {
            setLoading(false)
        }
    }

    if(loading || importing) {
        return (<div className="h-[60vh] relative pt-40"><Loading /></div>)
    }

    return (
        <div className="w-full">
            <section className="antialiased text-an_green-dark">
                <div className="flex flex-col items-center justify-center">
                    <div className="w-full">
                        <div>
                            { 
                                recipes?.length > 0 ?
                                    [...recipes]?.sort((a, b) => {
                                        return new Date(b?.created_at) - new Date(a?.created_at)
                                    }).map((r, index) => {
                                        return (
                                            <div key={index} className="w-full py-3 px-2 cursor-pointer odd:bg-an_white-dark hover:bg-an_white-darker1">
                                                <ImportedRecipeListItem   
                                                    importedRecipe={r}
                                                    onHandleRemove={handleOnRemoveImportedRecipe} 
                                                />
                                            </div> 
                                        )
                                    })
                                    : <p className="text-center">...</p>
                            }
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )

}